/**
 * @generated SignedSource<<879865ab6a2f44bbebe631798761cb9f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedRespRelatedItem_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useFavoritesItem_user">;
  readonly " $fragmentType": "SharedRespRelatedItem_user";
};
export type SharedRespRelatedItem_user$key = {
  readonly " $data"?: SharedRespRelatedItem_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRespRelatedItem_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRespRelatedItem_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useFavoritesItem_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "2531deb44b108cff3c593df1da84cc57";

export default node;
